function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC3751",
  fillRule: "nonzero",
  d: "M122.91 0h201.68c3.93 0 7.44 1.83 9.72 4.67L448.6 128.34c2.2 2.37 3.27 5.4 3.27 8.41l.05 310.01c0 35.42-29.4 64.8-64.8 64.8H122.91c-35.57 0-64.81-29.23-64.81-64.8V64.8C58.1 29.13 87.23 0 122.91 0zM330.5 37.15V90.1c2.4 31.33 23.57 42.98 52.94 43.49l36.15-.04-89.09-96.4zm96.51 121.3l-43.78-.03c-42.59-.69-74.12-21.97-77.53-66.55l-.1-66.95H122.91c-21.93 0-39.89 17.96-39.89 39.88v381.96c0 21.82 18.07 39.89 39.89 39.89h264.21c21.72 0 39.89-18.15 39.89-39.89V158.45z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC3751",
  d: "M28.04 194.61h453.92c15.42 0 28.04 12.65 28.04 28.04v188.54c0 15.4-12.65 28.05-28.04 28.05H28.04C12.65 439.24 0 426.62 0 411.19V222.65c0-15.42 12.62-28.04 28.04-28.04z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M86.71 256.46l13.35 32.31H102l13.35-32.31h41.99l-26.9 58.43 26.9 62.5h-42.96l-14.51-34.83h-1.74l-14.32 34.83H42.79l26.31-61.34-26.31-59.59h43.92zm156.25 120.93h-77.4V256.46h38.7v89.97h38.7v30.96zm4.35-2.13l5.42-31.92c11.87 2.96 22.54 4.45 32.02 4.45 9.48 0 17.13-.39 22.93-1.16v-9.68l-17.41-1.55c-15.74-1.42-26.54-5.19-32.41-11.32-5.87-6.12-8.81-15.19-8.81-27.18 0-16.51 3.58-27.86 10.74-34.06 7.16-6.19 19.32-9.28 36.47-9.28 17.16 0 32.64 1.61 46.44 4.83l-4.84 30.96c-11.99-1.93-21.6-2.9-28.82-2.9-7.23 0-13.36.32-18.39.97v9.48l13.94 1.35c16.89 1.68 28.57 5.71 35.02 12.1 6.45 6.38 9.67 15.25 9.67 26.6 0 8.13-1.1 15-3.29 20.61-2.19 5.61-4.8 9.87-7.83 12.77-3.04 2.9-7.33 5.13-12.87 6.67-5.55 1.55-10.42 2.49-14.61 2.81-4.19.32-9.77.48-16.74.48-16.77 0-32.31-1.67-46.63-5.03zm149.28-118.8l13.35 32.31h1.94l13.35-32.31h41.98l-26.89 58.43 26.89 62.5h-42.95l-14.51-34.83h-1.74l-14.32 34.83h-41.02l26.31-61.34-26.31-59.59h43.92z"
});

var SvgXlsxFileIcon = function SvgXlsxFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 510 511.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXlsxFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xlsx-file-icon.2a6ccbb1.svg";
export { ForwardRef as ReactComponent };